import React from 'react'
import PropTypes from 'prop-types'
import Image from '@boltui/image'

import * as Styled from '../../Footer.styles'

const imgPath = '//media.4rgos.it/i/Argos/checkout'

const checkoutImages = [
  { type: 'visa', path: `${imgPath}_visa` },
  { type: 'mastercard', path: `${imgPath}_mastercard` },
  { type: 'amex', path: `${imgPath}_amex` },
  { type: 'paypal', path: `${imgPath}_paypal` },
  { type: 'ssl', path: `${imgPath}_ssl` }
]

const footerCopy =
  'Argos Limited is authorised and regulated by the Financial Conduct Authority as a credit broker, and works exclusively with Argos Card Lender, Home Retail Group Card Services, who are authorised and regulated by the Financial Conduct Authority to provide credit (716148). Home Retail Group Card Services Limited is registered in England (04007072) at 489-499 Avebury Boulevard, Milton Keynes, Buckinghamshire MK9 2NW.'

const CheckoutFooter = ({ creditHidden = false }) => (
  <Styled.CheckoutFooter className='container container--row'>
    <Styled.CheckoutFooterRow className='md-row'>
      <div className='md-12' data-test='footer-checkout'>
        <Styled.CheckoutLogos>
          {checkoutImages.map((image) => (
            <Image
              key={image.type}
              src={image.path}
              alt={`${image.type} logo`}
              height={40}
              quality={80}
              data-test={`footer-checkout-logo`}
              responsive
              lazy
              lazyWrapElement={'span'}
            />
          ))}
        </Styled.CheckoutLogos>
        {!creditHidden && (
          <Styled.CreditCopy>
            <small data-test='footer-checkout-credit'>{footerCopy}</small>
          </Styled.CreditCopy>
        )}
      </div>
    </Styled.CheckoutFooterRow>
  </Styled.CheckoutFooter>
)

CheckoutFooter.propTypes = {
  creditHidden: PropTypes.bool
}

export default CheckoutFooter
